export function convertWeightFormKGtoLB(chargeableWeight: string | number, organizationName: string): string {
  // Convert number to string if needed
  const weightStr = typeof chargeableWeight === 'number' ? `${chargeableWeight} Kg` : chargeableWeight.trim();

  // Check if already in lb
  const isAlreadyInLb = /lb$/i.test(weightStr);
  if (isAlreadyInLb) {
    return weightStr;
  }

  // Extract KG value
  const weightMatch = weightStr.match(/^([\d.]+)\s*Kg$/i);
  if (!weightMatch) {
    console.warn(`[convertWeightFormKGtoLB] Invalid weight format: "${weightStr}". Returning original value.`);
    return `${weightStr}`; // fallback — don’t break the UI
  }

  const weightInKg = parseFloat(weightMatch[1]);

  if (organizationName.toLowerCase() === 'cargo solutions network') {
    const weightInLb = weightInKg * 2.20462;
    return `${weightInLb.toFixed(2)} lb`;
  }

  return weightStr;
}

export function convertWeightKGtoLB(weight: number): number {
  const result = weight * 2.20462;
  return parseFloat(result.toFixed(2));
}

export function customWeightRounding(value: number): number {
  const floor = Math.floor(value);
  const decimal = value - floor;

  if (decimal <= 0.04) {
    return floor;
  } else if (decimal <= 0.24) {
    return floor + 0.2;
  } else if (decimal <= 0.49) {
    return floor + 0.5;
  } else if (decimal <= 0.74) {
    return floor + 0.7;
  } else {
    return floor + 1;
  }
}

export function convertWeightByUnitOfMeasurement(
  unitOfMeasurement: string,
  displayChargeableWeight: string | number | undefined | null,
  organizationName: string,
): string {
  let weight = 0;

  if (typeof displayChargeableWeight === 'number') {
    weight = displayChargeableWeight;
  } else if (typeof displayChargeableWeight === 'string') {
    const parsed = parseFloat(displayChargeableWeight);
    weight = isNaN(parsed) ? 0 : parsed;
  }

  if (unitOfMeasurement.toLowerCase() === 'lb-in' && organizationName.toLowerCase() === 'cargo solutions network') {
    const weightInLb = weight * 2.20462;
    return `${weightInLb.toFixed(2)} lb`;
  }

  if (/kg/i.test(unitOfMeasurement)) {
    return `${weight.toFixed(2)} kg`;
  }

  return `${weight.toFixed(2)} ${unitOfMeasurement}`;
}
